import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './features18.css';

const Features99 = (props) => {
  const createHeadingFragment = (className, text) => (
    <span className={`initiatives-${className} thq-heading-2`}>
      {text}
    </span>
  )

  return (
    <div className="features18-layout349 thq-section-padding">
      <div className="features18-max-width thq-section-max-width">
        <div className="features18-content1">
          <div className="features18-section-title">
            <div className="features18-content2">
              <h2>
                {/* Use createHeadingFragment function here */}
                {props.feature1Title ?? createHeadingFragment('text49', 'Simplilearn, E-Learning Platform')}
              </h2>
              <p>
                {props.feature1Description ?? (
                  <Fragment>
                    <p className="features18-text3 thq-body-large" style={{ textAlign: 'justify' }}>
                    In collaboration with Simplilearn, industry-leading digital skills provider, the Commonwealth Secretariat is offering 10,000 free course slots to young learners across Commonwealth countries. This initiative, valued at USD 5 million, provides access to cutting-edge training in key areas such as artificial intelligence, machine learning, data science, cybersecurity, and software development. These courses, developed by leading industry experts from companies like IBM, Microsoft, and Meta, come with industry-recognized certification upon completion.
                    </p>
                    <span>
                      <a
                        href="https://thecommonwealth.org/news/simplilearn-partnership-commonwealth-launches-over-2000-e-learning-courses-young"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="initiatives-link thq-body-large"
                      >
                        <h5>Learn More...</h5>
                      </a>
                    </span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
        {/* Replacing video with image */}
        <div className="features18-image-container">

          <img
            alt={props.feature1ImageAlt ?? 'Image depicting AI'}
            src={props.feature1ImageSrc ?? '/1714041913701-1400w.jpeg'}
            className="thq-img-ratio-16-9"
            style={{ width: '100%', maxWidth: '640px', height: 'auto', objectFit: 'contain' }}
          />

        
        </div>
      </div>
    </div>
  );
};

Features99.defaultProps = {
  feature1Description: undefined,
  feature1ImageSrc: '/1714041913701-1400w.jpeg',
  feature1ImageAlt: 'Image depicting ethical standards',
  feature1Title: 'AI Entrepreneurship Make-A-Thon',
};

Features99.propTypes = {
  feature1Description: PropTypes.element,
  feature1ImageSrc: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature1Title: PropTypes.element,
};

export default Features99;
